import { Check } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToSection } from "@/lib/scroll";

const BASIC = [
  "6-week core agency immersion",
  "Filmmaking & editing fundamentals",
  "Color grading & sound basics",
  "Commercial storytelling craft",
  "2 live spec projects shipped",
  "Portfolio starter showreel",
];

const ADVANCED = [
  "12-week masterclass + AI director track",
  "Full camera + AI hybrid toolstack",
  "Guaranteed internship — Athrv Co. & partners",
  "Real client briefs & pitch rooms",
  "1-on-1 mentorship with creative directors",
  "Broadcast-grade showreel + credits",
];

const apply = (track) => {
  window.dispatchEvent(new CustomEvent("parallel:track", { detail: track }));
  scrollToSection("apply");
};

const Features = ({ items, featured }) => (
  <ul className="mt-8 space-y-4">
    {items.map((f) => (
      <li key={f} className="flex items-start gap-3">
        <Check className={`w-4 h-4 mt-0.5 shrink-0 ${featured ? "text-obsidian" : "text-acid"}`} strokeWidth={2.5} />
        <span className={`text-sm sm:text-base ${featured ? "text-obsidian/80" : "text-smoke"}`}>{f}</span>
      </li>
    ))}
  </ul>
);

export const Pricing = () => (
  <section id="programs" data-testid="programs-section" className="bg-obsidian py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="09" eyebrow="Two Tracks" title="Choose your intensity" />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
        <Reveal className="border border-line bg-ink p-8 sm:p-12 flex flex-col" data-testid="pricing-basic-card">
          <div className="flex items-center justify-between">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke">Track 01</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">6 Weeks</span>
          </div>
          <h3 className="mt-8 font-head text-3xl sm:text-4xl font-bold uppercase tracking-tight text-cream">Agency Basic</h3>
          <div className="mt-6 flex items-end gap-3">
            <span className="font-display font-extrabold text-5xl sm:text-6xl text-cream">₹35,000</span>
          </div>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-dim">Outcome — Agency-Ready Foundation</p>
          <Features items={BASIC} />
          <button
            data-testid="apply-basic-btn"
            onClick={() => apply("basic")}
            className="mt-10 border border-line text-cream font-mono text-xs uppercase tracking-[0.2em] px-8 py-4 hover:border-acid hover:text-acid transition-colors duration-300"
          >
            Apply For Basic
          </button>
        </Reveal>

        <Reveal delay={0.15} className="relative bg-acid text-obsidian p-8 sm:p-12 flex flex-col acid-glow" data-testid="pricing-advanced-card">
          <div className="absolute -top-px -right-px bg-obsidian text-acid font-mono text-[10px] font-bold uppercase tracking-[0.2em] px-4 py-2">
            Guaranteed Internship Track
          </div>
          <div className="flex items-center justify-between">
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-obsidian/60">Track 02</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-obsidian/60">12 Weeks</span>
          </div>
          <h3 className="mt-8 font-head text-3xl sm:text-4xl font-bold uppercase tracking-tight">Advanced Creative / AI</h3>
          <div className="mt-6 flex items-end gap-3">
            <span className="font-display font-extrabold text-5xl sm:text-6xl">₹1,50,000</span>
          </div>
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-obsidian/60">Outcome — Creative Director Trajectory</p>
          <Features items={ADVANCED} featured />
          <button
            data-testid="apply-advanced-btn"
            onClick={() => apply("advanced")}
            className="mt-10 bg-obsidian text-acid font-mono text-xs font-bold uppercase tracking-[0.2em] px-8 py-4 hover:scale-[1.02] active:scale-[0.98] transition-transform duration-300"
          >
            Apply For Advanced
          </button>
        </Reveal>
      </div>

      <Reveal className="mt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">Maximum 15 seats per track. Payment plans available on call.</p>
      </Reveal>
    </div>
  </section>
);
